import { useNavigate } from "react-router-dom"

const PageNotFound = () => {
    const navigate = useNavigate()

    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <h1 style={styles.code}>404</h1>
                <h2 style={styles.title}>Page not found</h2>
                <p style={styles.subtitle}>
                    Oops! The page you’re looking for doesn’t exist or was moved.
                </p>

                <div style={styles.actions}>
                    <button style={styles.primaryBtn} onClick={() => navigate("/")}>
                        Go to Home
                    </button>
                    <button style={styles.secondaryBtn} onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    )
}

const styles = {
    wrapper: {
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "16px"
    },
    card: {
        background: "#fff",
        borderRadius: "16px",
        padding: "48px 32px",
        maxWidth: "420px",
        width: "100%",
        textAlign: "center",
        boxShadow:
            "0 10px 30px rgba(0,0,0,0.15)"
    },
    code: {
        fontSize: "96px",
        margin: 0,
        fontWeight: 800,
        color: "#667eea",
        lineHeight: 1
    },
    title: {
        fontSize: "24px",
        margin: "16px 0 8px",
        color: "#111"
    },
    subtitle: {
        fontSize: "14px",
        color: "#555",
        marginBottom: "32px"
    },
    actions: {
        display: "flex",
        gap: "12px",
        justifyContent: "center"
    },
    primaryBtn: {
        padding: "10px 18px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        background: "#667eea",
        color: "#fff",
        fontWeight: 600
    },
    secondaryBtn: {
        padding: "10px 18px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        cursor: "pointer",
        background: "#fff",
        color: "#333",
        fontWeight: 500
    }
}

export default PageNotFound
